import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showAlert, showNotification, catchHandler } from "@/utils/helpers";


export default {
    namespaced: true,
    state: {
        patients: [],
        patient: {
            id: null,
            fullName: null,
            socialStatus: null,
            bloodType: null,
            address: null,
            birthDate: null,
            phoneNo: null,
            identityNo: null,
            gender: null,
            relativePhoneNo: null,
            relativeName: null,
            createdBy: null,
            createdOn: null,
            status: null,
        },
        totalItems: 0,
    },
    getters: {
        index: state => (id) => state.patients.findIndex(i => i.id === id)
    },
    mutations: {
        SET_PATIENTS: (state, data) => state.patients = data,
        SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
        SET_PATIENT: (state, viewData) => state.patient = viewData,
        ADD: (state, addedData) => state.patients.unshift(addedData),
        UPDATE: (state, { index, updateData }) => state.patients.splice(index, 1, updateData),
        DELETE: (state, index) => state.patients.splice(index, 1),
    },
    actions: {
        async getAll({ commit }, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");

                const response = await dataService.patients.getAll(paramsString);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_PATIENTS', response.data.patients);
                commit('SET_TOTAL_ITEMS', response.data.totalItems);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getDetails({ commit }, id) {
            startLoading()
            try {
                commit('SET_PATIENT', {});
                const response = await dataService.patients.getDetails(id);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_PATIENT', response.data.patient);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        }, 
         async getForEdit(_, id) {
            startLoading()
            try {
                const response = await dataService.patients.getForEdit(id);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                return Promise.resolve(response.data.patient);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
       

        async add({ commit }, payload) {
            startLoading()
            try {
                const response = await dataService.patients.add(payload);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);
                commit('ADD', response.data.patient);
            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);

            }
        },
        async edit({ commit, getters }, { id, payload }) {
            startLoading()
            try {
                const response = await dataService.patients.edit(id,payload);

                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('UPDATE', { index: index, updateData: response.data.patient });

            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);

            }
        },
        async delete({ commit, getters }, id) {
            startLoading()
            try {
                const response = await dataService.patients.delete(id);

                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('DELETE', index);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
    },
};
